import React from 'react';
import {
    SkeletonBodyText
} from '@shopify/polaris';
import { mapFromFilter, apiFetch as fetch } from '../../common/Helpers';
import { Helmet } from 'react-helmet';
import TagValidationComponent from '../../components/TagValidationComponent';

class ValidationsEditPage extends React.Component {

    constructor(props) {
        super(props)

        const { params } = this.props.match;
        this.state = {
            id: params.id,
            isLoading: true,
        };
    }

    render() {

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Edit Validation - {this.state.id}</title>
                </Helmet>
                {this.state.isLoading && <SkeletonBodyText lines="20" />}
                {!this.state.isLoading && <TagValidationComponent
                    validation={this.state.validation}
                    onSave={this.handleSave}
                    onDelete={this.handleDelete} />}
            </div>
        );
    }

    handleSave = async (tagValidation) => {

        fetch(`api/validations/${this.state.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(tagValidation)
        }).then(() => {
            this.props.history.push("/validations");
        });
    }

    handleDelete = () => {

        fetch(`api/validations/${this.state.id}`, {
            method: 'DELETE',
        }).then(() => {
            this.props.history.push("/validations");
        });
    }

    componentDidMount() {
        fetch(`api/validations/${this.state.id}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                validation: {
                    id: data.id,
                    name: data.name,
                    invalidProducts: data.invalidProducts,
                    rule: data.rule,
                    precondition: data.precondition != null ? mapFromFilter(data.precondition.children[0]) : null
                },
                isLoading: false
            }));
    }
}

export default ValidationsEditPage;